/**
 * @packageDocumentation
 * @module f1/is
 */

import match from '../str/match';

export interface IsLike {
  /**
   * Does the string or regex match
   *
   * @public
   * @function f1.is.like
   * @example
   *
   * ```ts
   * f1.is.like('hi', 'he said hi to me') => true
   * f1.is.like(/\shi\s/, 'he said hi to me') => true
   * f1.is.like(/\sme\s/, 'he said hi to me') => false
   * ```
   */
  (regExp: RegExp | string, s: string): boolean;
  (regExp: RegExp | string): (s: string) => boolean;
}

/**
 * @see IsLike
 */
export default (regExp: RegExp | string, s: string): boolean => {
  return match(regExp, s).length !== 0;
};
